import React from 'react';
import {
    AiOutlineOrderedList,
    AiOutlineIdcard,
    AiOutlineUserAdd,
    AiOutlineUsergroupAdd,
    AiOutlineSend,
    AiOutlineUsergroupDelete,
    AiOutlineUserDelete,
    AiOutlineSearch,
    AiOutlineEdit,
    AiOutlineLock,
    AiOutlineMail,
    AiOutlinePicture, 
    AiOutlineClockCircle,
    AiOutlineFileText,
    AiOutlineDeploymentUnit,
    AiOutlineFileSearch
} from 'react-icons/ai';
import {
    RiUserSettingsLine
} from 'react-icons/ri';

let IconCard = (props) => {
    const getIcon = (icon) =>{
        switch (icon) {
            case 'AiOutlineIdcard':
                return <AiOutlineIdcard />
            case 'AiOutlineMail':
                return <AiOutlineMail />
            case 'AiOutlineUserAdd':
                return <AiOutlineUserAdd />
            case 'AiOutlineUsergroupAdd':
                return <AiOutlineUsergroupAdd />
            case 'AiOutlineUsergroupDelete':
                return <AiOutlineUsergroupDelete />
            case 'AiOutlineSend':
                return <AiOutlineSend />
            case 'AiOutlineUserDelete':
                return <AiOutlineUserDelete />
            case 'AiOutlineSearch':
                return <AiOutlineSearch />
            case 'AiOutlineEdit':
                return <AiOutlineEdit />
            case 'AiOutlineLock':
                return <AiOutlineLock />
            case 'AiOutlinePicture':
                return <AiOutlinePicture />
            case 'AiOutlineClockCircle':
                return <AiOutlineClockCircle />
            case 'AiOutlineFileText':
                return <AiOutlineFileText />
            case 'AiOutlineDeploymentUnit':
                return <AiOutlineDeploymentUnit />
            case 'AiOutlineFileSearch':
                return <AiOutlineFileSearch />
            case 'RiUserSettingsLine':
                return <RiUserSettingsLine />
            case 'AiOutlineOrderedList':
            default:
                return <AiOutlineOrderedList />
        }
    }
    return (
        <div className='icon-card'>
            <div className='icon-card-content' onClick={() => props.onClick()}>
                <div style={{ fontSize: 100 }}>{props.icon ? getIcon(props.icon) : (props.mainText ? props.mainText :'#')}</div>
                <div style={{ fontSize: 24, textAlign:'center' }}>{props.subText}</div>
            </div>
        </div>
    );
}
export default IconCard;